// export const baseStorageUrl = "http://127.0.0.1:8000/storage";
export const baseStorageUrl = "https://shop.kempes.bg/storage/";

// export const baseUrl = "http://127.0.0.1:8000";
export const baseUrl = "https://shop.kempes.bg";
